  <app-header-latest></app-header-latest>
<section class="rec-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow" style="background:rgba(255,255,255,0.1);color:#fff;border-color:rgba(255,255,255,0.2);">🎯 AI-Powered ATS</div>
      <h1>Hire the<br><span style="color:#FCA5A5;">Best Talent,</span><br>Faster.</h1>
      <p>End-to-end hiring from job posting to offer letter — with AI-powered screening, automated scheduling, and collaborative decision-making.</p>
      <div style="display:flex;gap:16px;margin-top:30px;">
        <a href="#" class="btn btn-white">Start Hiring Now</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">View ATS Demo</a>
      </div>
    </div>
    <div>
      <div class="job-stats-widget">
        <div class="job-stats-row">
          <div class="job-stat-item"><div class="job-stat-val">34</div><div class="job-stat-lbl">Open Roles</div></div>
          <div class="job-stat-item"><div class="job-stat-val">287</div><div class="job-stat-lbl">Applications</div></div>
          <div class="job-stat-item"><div class="job-stat-val">12</div><div class="job-stat-lbl">Interviews</div></div>
        </div>
        <div class="job-listing-mini">
          <div class="job-mini-item"><span>Senior React Engineer</span><span class="job-mini-tag">48 Apps</span></div>
          <div class="job-mini-item"><span>Product Designer</span><span class="job-mini-tag">32 Apps</span></div>
          <div class="job-mini-item"><span>DevOps Lead</span><span class="job-mini-tag">19 Apps</span></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 2: KANBAN PIPELINE ──────────────────────────── -->
<section class="pipeline-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📋 Hiring Pipeline</span>
      <h2 class="sec-h2">Visual Kanban ATS<br><span class="gradient-text">Built for Speed</span></h2>
      <p class="sec-sub">Drag candidates through your hiring stages. Set SLAs, assign reviewers, and never lose track of top talent.</p>
    </div>
    <div class="pipeline-board">
      <div class="pipeline-col">
        <div class="pipeline-col-title">Applied <span class="pipeline-count">8</span></div>
        <div class="candidate-card"><div class="cand-name">James Whitfield</div><div class="cand-role">Sr. React Engineer</div><div class="cand-skills"><span class="cand-skill">React</span><span class="cand-skill">Node.js</span></div><div class="cand-score"><span>AI Match</span><span class="ai-badge">92%</span></div></div>
        <div class="candidate-card"><div class="cand-name">Priya Sharma</div><div class="cand-role">Frontend Developer</div><div class="cand-skills"><span class="cand-skill">Vue</span><span class="cand-skill">TypeScript</span></div><div class="cand-score"><span>AI Match</span><span class="ai-badge">87%</span></div></div>
      </div>
      <div class="pipeline-col">
        <div class="pipeline-col-title">Screening <span class="pipeline-count">5</span></div>
        <div class="candidate-card"><div class="cand-name">David Park</div><div class="cand-role">Fullstack Engineer</div><div class="cand-skills"><span class="cand-skill">Next.js</span><span class="cand-skill">PostgreSQL</span></div><div class="cand-score"><span>AI Match</span><span class="ai-badge">89%</span></div></div>
      </div>
      <div class="pipeline-col">
        <div class="pipeline-col-title">Interview <span class="pipeline-count">3</span></div>
        <div class="candidate-card"><div class="cand-name">Anika Patel</div><div class="cand-role">Product Designer</div><div class="cand-skills"><span class="cand-skill">Figma</span><span class="cand-skill">UX Research</span></div><div class="cand-score"><span>AI Match</span><span class="ai-badge">94%</span></div></div>
      </div>
      <div class="pipeline-col">
        <div class="pipeline-col-title">Offer Sent <span class="pipeline-count">2</span></div>
        <div class="candidate-card"><div class="cand-name">Marcus Johnson</div><div class="cand-role">DevOps Lead</div><div class="cand-skills"><span class="cand-skill">AWS</span><span class="cand-skill">Kubernetes</span></div><div class="cand-score"><span>AI Match</span><span class="ai-badge">91%</span></div></div>
      </div>
      <div class="pipeline-col">
        <div class="pipeline-col-title">Hired ✓ <span class="pipeline-count">4</span></div>
        <div class="candidate-card" style="border-color:#86EFAC;"><div class="cand-name">Lisa Chen</div><div class="cand-role">Sr. Product Manager</div><div class="cand-skills"><span class="cand-skill">Roadmapping</span><span class="cand-skill">Agile</span></div><div class="cand-score"><span>Hire Date</span><span style="font-size:12px;color:#15803D;font-weight:700;">Feb 1</span></div></div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 3: AI SCREENING ─────────────────────────────── -->
<section class="screening-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🤖 AI Screening Engine</span>
      <h2 class="sec-h2">Rank Every Applicant<br><span class="gradient-text">Before the First Call</span></h2>
      <p class="sec-sub">Our AI reads resumes in milliseconds, scores fit against job requirements, and surfaces only your top candidates.</p>
    </div>
    <div class="screening-section__grid">
      <div class="screening-card"><div class="screening-card__icon">🧠</div><div class="screening-card__title">Resume Parsing AI</div><div class="screening-card__desc">Instantly extracts skills, experience, education, and custom signals from any resume format — PDF, DOCX, LinkedIn.</div><span class="screening-card__badge">GPT-4 Powered</span></div>
      <div class="screening-card"><div class="screening-card__icon">📊</div><div class="screening-card__title">Fit Score Calculator</div><div class="screening-card__desc">Scores each application against your custom job criteria with explainable scoring — so your team understands every decision.</div><span class="screening-card__badge">Explainable AI</span></div>
      <div class="screening-card"><div class="screening-card__icon">🎯</div><div class="screening-card__title">Bias Detection</div><div class="screening-card__desc">Automatically flags potentially biased job descriptions and anonymizes candidate identifiers during initial screening rounds.</div><span class="screening-card__badge">EEOC Ready</span></div>
    </div>
  </div>
</section>

<!-- ── SECTION 4: JOB BUILDER ──────────────────────────────── -->
<section class="job-builder-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">✍️ Job Post Builder</span>
      <h2 class="sec-h2">Publish Optimized Roles<br><span class="gradient-text">in 3 Minutes</span></h2>
    </div>
    <div class="job-builder-section__inner">
      <div class="job-preview-card">
        <div class="job-preview-card__header">
          <div class="job-preview-card__title">Senior Product Manager</div>
          <div class="job-preview-card__status">● Live</div>
        </div>
        <div class="job-preview-card__meta">
          <span>📍 Remote (Global)</span>
          <span>💼 Full-Time</span>
          <span>💰 $130K–$160K</span>
        </div>
        <div class="job-preview-card__desc">Lead the product vision and roadmap for our core HR platform. Work cross-functionally with engineering, design, and commercial teams to deliver impactful features for 12,000+ customers.</div>
        <div class="job-preview-card__tags">
          <span class="job-preview-card__tag">5+ yrs Experience</span>
          <span class="job-preview-card__tag">HRMS Domain</span>
          <span class="job-preview-card__tag">B2B SaaS</span>
          <span class="job-preview-card__tag">Data-Driven</span>
        </div>
      </div>
      <div class="builder-features">
        <div class="builder-feat"><div class="builder-feat__icon">📝</div><div><div class="builder-feat__title">AI Job Description Generator</div><div class="builder-feat__desc">Type a job title and role brief — our AI writes a complete, optimized JD in seconds.</div></div></div>
        <div class="builder-feat"><div class="builder-feat__icon">📢</div><div><div class="builder-feat__title">Multi-Board Distribution</div><div class="builder-feat__desc">Publish to LinkedIn, Indeed, Glassdoor, and your careers page from a single dashboard click.</div></div></div>
        <div class="builder-feat"><div class="builder-feat__icon">📈</div><div><div class="builder-feat__title">Application Analytics</div><div class="builder-feat__desc">Track views, click-throughs, and source quality for every job listing in real-time.</div></div></div>
      </div>
    </div>
  </div>
</section>

<!-- ── SECTION 5: STATS ────────────────────────────────────── -->
<section class="rec-stats-section">
  <div class="container-wrapper">
    <div class="rec-stats-section__grid">
      <div class="rec-stat"><div class="rec-stat__val">3.4x</div><div class="rec-stat__lbl">Faster Time-to-Hire</div></div>
      <div class="rec-stat"><div class="rec-stat__val">68%</div><div class="rec-stat__lbl">Reduction in Screening Time</div></div>
      <div class="rec-stat"><div class="rec-stat__val">92%</div><div class="rec-stat__lbl">Offer Acceptance Rate</div></div>
      <div class="rec-stat"><div class="rec-stat__val">40+</div><div class="rec-stat__lbl">Job Board Integrations</div></div>
    </div>
  </div>
</section>

<!-- ── SECTION 6: CTA ──────────────────────────────────────── -->
<section class="rec-cta">
  <div class="container-wrapper">
    <h2 class="rec-cta__h2">Your Next Great Hire<br>is One Click Away.</h2>
    <p class="rec-cta__p">Start your free trial and make your first hire in under a week.</p>
    <div class="rec-cta__actions">
      <a href="#" class="btn btn-white">Start Hiring Free</a>
      <a href="contact.html" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.4);">Request a Demo</a>
    </div>
  </div>
</section>

<app-peopleflow-footer></app-peopleflow-footer>